import { CampaignMessage } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorState';
import { WebsiteContentMessage } from 'sections/onsite-campaigns/types';
import { useGetEditOrActual } from '../../../../../state/CampaignSettings/selectors/useGetEditOrActual';

export const useDisplayWebContentSelector = ({
  messageId,
}: {
  messageId: string;
}): CampaignMessage<WebsiteContentMessage> => {
  const state = useGetEditOrActual();

  return state.messages[messageId];
};
